import {isDefined} from "../../libs/utils/epic.utils";

export class AffiliateReferredDto {

  public id!: string;
  public readonly date!: Date;
  public readonly commission!: number;

  constructor(init?: Partial<AffiliateReferredDto> | undefined) {
    Object.assign(this, init);
    if (isDefined(init?.date)) {
      this.date = new Date(init?.date);
    }
  }
}
